interface Props {
  currentIndex: number
  total: number
  onPrev: () => void
  onNext: () => void
  onDismiss: () => void
}

export default function HighlightNav({ currentIndex, total, onPrev, onNext, onDismiss }: Props) {
  return (
    <div className="bg-surface border-t border-elevated shrink-0 px-4 py-3 flex items-center justify-between">
      <button
        onClick={onPrev}
        disabled={currentIndex <= 0}
        className="p-2 text-text-secondary hover:text-text-primary disabled:opacity-30 transition-colors"
        aria-label="Previous match"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>

      <span className="text-sm text-text-secondary">
        {currentIndex + 1} of {total}
      </span>

      <button
        onClick={onNext}
        disabled={currentIndex >= total - 1}
        className="p-2 text-text-secondary hover:text-text-primary disabled:opacity-30 transition-colors"
        aria-label="Next match"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>

      <button
        onClick={onDismiss}
        className="p-2 text-text-secondary hover:text-text-primary transition-colors"
        aria-label="Dismiss highlights"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
